import React from "react";
import EnrichedPlayerPluginEditor from "./components/EnrichedPlayerPluginEditor.js";
import i18n from "i18next";
import { convertSecondsToHMS } from "../../common/common_tools";

require("./EnrichedPlayer.scss");

export function EnrichedPlayer(base) {
  return {
    getConfig: function () {
      return {
        name: "EnrichedPlayer",
        flavor: "react",
        isRich: true,
        displayName: IdealStudio.i18n.t("EnrichedPlayer.PluginName"),
        category: "multimedia",
        initialWidth: "44%",
        initialHeight: "44%",
        initialWidthSlide: "44%",
        initialHeightSlide: "44%",
        icon: "play_arrow",
        aspectRatioButtonConfig: {
          location: ["main", "structure"],
          defaultValue: true,
        },
        marksType: {
          name: i18n.t("EnrichedPlayer.pos"),
          key: "value",
          format: "[h:m:s/m:s]",
          default: "0:00",
          defaultColor: "#eab700",
        },
        createFromLibrary: ["video/*", "url"],
        searchIcon: true,
      };
    },
    getToolbar: function (state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            basic: {
              __name: IdealStudio.i18n.t("EnrichedPlayer.Video"),
              icon: "link",
              buttons: {
                url: {
                  __name: IdealStudio.i18n.t("EnrichedPlayer.URL"),
                  type: "external_provider",
                  value: state.url,
                  accept: "video/*",
                },
                controls: {
                  __name: IdealStudio.i18n.t("EnrichedPlayer.Show_controls"),
                  type: "checkbox",
                  checked: state.controls,
                },
                autoPlay: {
                  __name: IdealStudio.i18n.t("EnrichedPlayer.AutoPlay"),
                  type: "checkbox",
                  checked: state.autoPlay,
                },
                loop: {
                  __name: IdealStudio.i18n.t("EnrichedPlayer.Loop"),
                  type: "checkbox",
                  checked: state.loop,
                },
              },
            },
            style: {
              __name: IdealStudio.i18n.t("EnrichedPlayer.box_style"),
              icon: "palette",
              buttons: {
                borderWidth: {
                  __name: IdealStudio.i18n.t("EnrichedPlayer.border_size"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 10,
                },
                borderStyle: {
                  __name: IdealStudio.i18n.t("EnrichedPlayer.border_style"),
                  type: "select",
                  value: "solid",
                  options: [
                    "none",
                    "hidden",
                    "dotted",
                    "dashed",
                    "solid",
                    "double",
                    "groove",
                    "ridge",
                    "inset",
                    "outset",
                    "initial",
                    "inherit",
                  ],
                  labels: [
                    i18n.t("styles.border_style_options.none") || "none",
                    i18n.t("styles.border_style_options.hidden") || "hidden",
                    i18n.t("styles.border_style_options.dotted") || "dotted",
                    i18n.t("styles.border_style_options.dashed") || "dashed",
                    i18n.t("styles.border_style_options.solid") || "solid",
                    i18n.t("styles.border_style_options.double") || "double",
                    i18n.t("styles.border_style_options.groove") || "groove",
                    i18n.t("styles.border_style_options.ridge") || "ridge",
                    i18n.t("styles.border_style_options.inset") || "inset",
                    i18n.t("styles.border_style_options.outset") || "outset",
                    i18n.t("styles.border_style_options.initial") || "initial",
                    i18n.t("styles.border_style_options.inherit") || "inherit",
                  ],
                },
                borderColor: {
                  __name: IdealStudio.i18n.t("EnrichedPlayer.border_color"),
                  type: "color",
                  value: "#000000",
                },
                borderRadius: {
                  __name: IdealStudio.i18n.t("EnrichedPlayer.radius"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 50,
                },
                opacity: {
                  __name: IdealStudio.i18n.t("EnrichedPlayer.opacity"),
                  type: "range",
                  value: 1,
                  min: 0,
                  max: 1,
                  step: 0.05,
                },
              },
            },
          },
        },
      };
    },
    getInitialState: function () {
      return {
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/Video/taslak.mp4",
        controls: true,
        autoPlay: true,
        volume: 1,
        loop: false,
      };
    },
    getRenderTemplate: function (state, props) {
      return (
        <div style={{ width: "100%", height: "100%" }}>
          <EnrichedPlayerPluginEditor
            style={{ width: "100%", height: "100%" }}
            state={state}
            base={base}
            props={props}
          />
        </div>
      );
    },
    getDefaultMarkValue(state) {
      return "0:00";
    },
    parseRichMarkInput: function (x, y, width, height, toolbarState, boxId) {
      let parsed_value = (x + 10) / width;
      let duration = $("#box-" + boxId + " .enriched-player-wrapper").attr("duration");
      return convertSecondsToHMS(duration * parsed_value);
    },
    validateValueInput: function (value) {
      let regex = /^((\d+:)?[0-5]?[0-9]?:[0-5]\d$)/g;
      let match = regex.exec(value);
      if (match && match.length === 3) {
        // let val = match[1];
        return { isWrong: false, value: value };
      }

      return { isWrong: true, message: i18n.t("EnrichedPlayer.message_mark_error") };
    },
  };
}
/* eslint-enable react/prop-types */
